import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { borrowerStatusOptions } from 'app/services/borrower-status/status-options';
import { dealStatusOptions } from 'app/services/deals/deal-status-options';

@Pipe({
  name: 'statusDisplay',
  standalone: false
})
export class StatusDisplayPipe implements PipeTransform {
    private borrowerStatuses;
    private dealStatuses;

    constructor() {
        this.borrowerStatuses = borrowerStatusOptions;
        this.dealStatuses = dealStatusOptions;
    }

    transform(value: string): string {
        if (typeof value === 'undefined') {
            return '';
        }

        let status;

        if (_.includes(this.dealStatuses, value)) {
            status = this.dealStatuses[value].display;
        } else if (_.includes(this.borrowerStatuses, value)) {
            status = this.borrowerStatuses[value].display;
        } else {
            status = _.startCase(_.camelCase(value));
        }

        return status;
    }
}

